import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useDocumentTitle = (title: string) => {
	const { t } = useTranslation('entities');
	useEffect(() => {
		document.title = title
			? `${t(`entities:${title}`)} - Agroambiente`
			: 'Agroambiente';
	}, [title]);
};
